import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ContentChild,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { SalesDocument } from '@icc/b2b/shared';
import { core } from '@icc/shared';
import { isObject } from '@icc/shared/helpers/b2b';
import { DocumentDetailContentDirective } from './document-detail-content.directive';

@Component({
    selector: 'icc-document-detail',
    templateUrl: './document-detail.component.html',
    styleUrls: ['./document-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentDetailComponent<T extends keyof SalesDocument> implements OnChanges {
    difference = false;
    @Input() documentList: SalesDocument[];
    @Input() document: SalesDocument | null = null;
    @Input() property: T;
    @ContentChild(DocumentDetailContentDirective) content!: DocumentDetailContentDirective;

    context: {
        value: any;
    } = {
        value: null,
    };

    @Input() transform?: (value: any) => any = (value) => value;

    ngOnChanges(): void {
        if (this.document) {
            this.context.value = this.transform(this.document[this.property]);
            this.difference = false;
        } else if (this.documentList?.length) {
            let matching = true;
            const firstValue = this.transform(this.documentList[0][this.property]);
            for (const document of this.documentList) {
                if (!this.deepCompare(firstValue, this.transform(document[this.property]))) {
                    matching = false;
                    break;
                }
            }
            this.difference = !matching;
            this.context.value = firstValue;
        }
    }

    deepCompare(a: any, b: any) {
        let isObjects = isObject(a) && isObject(b);
        if (!isObjects) {
            return a == b;
        }

        const objKeys1 = Object.keys(a);
        const objKeys2 = Object.keys(b);

        if (objKeys1.length !== objKeys2.length) return false;

        for (const key of objKeys1) {
            const value1 = a[key];
            const value2 = b[key];

            isObjects = isObject(value1) && isObject(value2);

            if (
                (isObjects && !this.deepCompare(value1, value2)) ||
                (!isObjects && value1 != value2)
            ) {
                return false;
            }
        }
        return true;
    }
}
